import { render, staticRenderFns } from "./UpdatePwd.vue?vue&type=template&id=8c1b9a98&scoped=true&"
import script from "./UpdatePwd.vue?vue&type=script&lang=js&"
export * from "./UpdatePwd.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePwd.vue?vue&type=style&index=0&id=8c1b9a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1b9a98",
  null
  
)

export default component.exports